import { AppConfig } from '@acpgruppe/essp-ui';
import { environment } from './environment';


export const appConfig: AppConfig = {
    portalHomeUrl: environment.portalHomeUrl,
    backendUrl: environment.marketplaceBillingBackendUrl,
    metaBackendUrl: environment.portalMetaBackendUrl,
    oauth: {
        issuer: environment.issuer,
        tokenEndpoint: environment.tokenEndpoint,
        clientId: environment.clientId,
        scope: environment.scope
    },
    appInfo: {
        appName: environment.appName,
        appVersion: environment.appVersion
    },
    privilegesUrl: environment.marketplaceBillingBackendUrl + '/privileges',
    stomp: { enable: true},
    errorUrl: '/marketplacebilling/errorPage',
}
